import clsx from "clsx"
import type { PropsWithChildren } from "react"
import "./style.scss"

interface IProps extends PropsWithChildren {
  className?: string
}

export const PageWrapper = ({ className, children }: IProps) => {
  return <div className={clsx("page-wrapper", className)} children={children} />
}
